import { render, staticRenderFns } from "./ApplicationManagement.vue?vue&type=template&id=b06f1138&"
import script from "./ApplicationManagement.vue?vue&type=script&lang=js&"
export * from "./ApplicationManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports